import { render, staticRenderFns } from "./FulfillmentBatch.vue?vue&type=template&id=415f4279&scoped=true"
import script from "./FulfillmentBatch.vue?vue&type=script&lang=js"
export * from "./FulfillmentBatch.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentBatch.vue?vue&type=style&index=0&id=415f4279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f4279",
  null
  
)

export default component.exports